import { render, staticRenderFns } from "./FileDownloadLink.vue?vue&type=template&id=1b351d8f&"
import script from "./FileDownloadLink.vue?vue&type=script&lang=js&"
export * from "./FileDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports